import { render } from "./MaterialScan.vue?vue&type=template&id=0d6d5c56&scoped=true"
import script from "./MaterialScan.vue?vue&type=script&lang=js"
export * from "./MaterialScan.vue?vue&type=script&lang=js"

import "./MaterialScan.vue?vue&type=style&index=0&id=0d6d5c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6d5c56"]])

export default __exports__